// Owner in P2: piece 16 "Lists and waves" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/waves`, one lazy chunk. No rail entry: it is reached from Lists. The
// URL carries ids only: `wave` is the open wave, `list` the shared list a new wave starts from.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { Feature } from '../feature.ts'
import { parseSearch } from './queries.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/waves',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./WavesScreen.tsx')),
    }),
  ],
  nav: [],
}
